<template>
  <div class="modal fade" v-bind:id="'inviteUserModal' + ModalId">
    <Loader v-if="loading" />
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Invite New User</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h6 class="text-danger" v-if="errorMessage != ''">
            {{ errorMessage }}
          </h6>
          <transition name="slide-fade" mode="out-in">
            <form v-if="page == 1" @submit.prevent="nextPage()" key="email">
              <div class="form-group">
                <label for="newEmail">Email Address</label>
                <input
                  type="email"
                  class="form-control"
                  id="newEmail"
                  aria-describedby="emailHelp"
                  placeholder="Email"
                  autocomplete="username"
                  v-model="newEmail"
                  required
                />
              </div>
              <div class="form-group">
                <label for="newConfirmEmail">Confirm Email Address</label>
                <input
                  type="email"
                  class="form-control"
                  id="newConfirmEmail"
                  aria-describedby="emailHelp"
                  placeholder="Confirm Email"
                  autocomplete="username"
                  v-model="newConfirmEmail"
                  required
                />
              </div>
              <div class="row text-left">
                <div class="col">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    v-on:click="cancel"
                  >
                    Cancel
                  </button>
                </div>
                <div class="col-auto">
                  <button type="submit" class="btn btn-primary">
                    Next
                  </button>
                </div>
              </div>
            </form>
            <form
              v-if="page == 2 && !existingUser"
              @submit.prevent="nextPage()"
              key="userDetails"
            >
              <div class="form-group">
                <label for="newFirstName">Email</label>
                <input
                  type="text"
                  class="form-control"
                  id="newFirstName"
                  placeholder="First Name"
                  v-model="newEmail"
                  disabled
                />
              </div>
              <div class="form-group">
                <label for="newFirstName">First Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="newFirstName"
                  placeholder="First Name"
                  v-model="newFirstName"
                  required
                />
              </div>
              <div class="form-group">
                <label for="newLastName">Last Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="newLastName"
                  placeholder="Last Name"
                  v-model="newLastName"
                  required
                />
              </div>
              <div class="form-group">
                <label for="newPhone">Phone</label>
                <input
                  type="text"
                  class="form-control"
                  id="newPhone"
                  aria-describedby="phoneHelp"
                  placeholder="Phone (Optional)"
                  v-model="newPhone"
                />
              </div>
              <div class="row text-left">
                <div class="col">
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-on:click="previousPage"
                  >
                    Back
                  </button>
                </div>
                <div class="col-auto">
                  <button type="submit" class="btn btn-primary">
                    Next
                  </button>
                </div>
              </div>
            </form>
            <div v-if="page == 2 && existingUser">
              <label for="newFirstName"
                >A user with the email {{ newEmail }} already exists ({{
                  existingUser.First_Name
                }}
                {{ existingUser.Last_Name }}). Would you like to add this user
                to your school and give them permissions?</label
              >
              <div class="row text-left">
                <div class="col">
                  <button
                    class="btn btn-danger"
                    type="button"
                    v-on:click="previousPage"
                  >
                    Back
                  </button>
                </div>
                <div class="col-auto">
                  <button
                    class="btn btn-primary"
                    type="button"
                    v-on:click="nextPage"
                  >
                    Invite This User
                  </button>
                </div>
              </div>
            </div>

            <form
              v-if="page == 3"
              @submit.prevent="nextPage()"
              key="accountPermissions"
            >
              <label for="accountpermission">Account Permissions</label>
              <label
                ><small
                  >Not selecting one of the options will give no account level
                  permissions to the user.</small
                ></label
              >
              <div
                v-for="permission in Permissions.filter(
                  g => g.Permission_Type.Permission_Type_Id == '1'
                )"
                :key="'account' + permission.Permission_Id"
              >
                <label
                  class="btn btn-sm"
                  v-bind:for="'account' + permission.Permission_Id"
                  v-bind:class="{
                    'btn-primary':
                      newUserAccountPermissions == permission.Permission_Id,
                    'btn-outline-primary':
                      newUserAccountPermissions != permission.Permission_Id
                  }"
                >
                  <input
                    style="display: none"
                    type="radio"
                    v-bind:name="'account' + permission.Permission_Id"
                    v-bind:id="'account' + permission.Permission_Id"
                    v-bind:value="permission.Permission_Id"
                    v-model="newUserAccountPermissions"
                  />{{ permission.Title }}
                </label>
              </div>

              <label v-if="newUserAccountPermissions != null"
                ><small>{{
                  Permissions.find(
                    permission =>
                      permission.Permission_Id == newUserAccountPermissions
                  ).Description
                }}</small></label
              >
              <div class="row text-left mt-2">
                <div class="col">
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-on:click="previousPage"
                  >
                    Back
                  </button>
                </div>
                <div class="col-auto">
                  <button type="submit" class="btn btn-primary">
                    Next
                  </button>
                </div>
              </div>
            </form>
            <form
              v-if="page == 4"
              @submit.prevent="nextPage()"
              key="organizationPermissions"
            >
              <label>Organization Permissions</label>
              <label
                ><small
                  >Not selecting one of the options will give no organization
                  level permissions to the user. If the user was given account
                  level permissions, they will apply to the organizations
                  listed.</small
                ></label
              >
              <div
                v-for="org in availableOrganizations"
                :key="org.Organization_Id"
              >
                <p>
                  <b>{{ org.Name }}</b>
                </p>
                <div
                  v-for="permission in Permissions.filter(
                    g => g.Permission_Type.Permission_Type_Id == '2'
                  )"
                  :key="org.Organization_Id + 'org' + permission.Permission_Id"
                >
                  <label
                    class="btn btn-sm"
                    v-bind:for="
                      org.Organization_Id + 'org' + permission.Permission_Id
                    "
                    v-bind:class="{
                      'btn-primary': newUserOrganizationPermissions.some(
                        i =>
                          i.organization == org.Organization_Id &&
                          i.permission == permission.Permission_Id
                      ),
                      'btn-outline-primary': !newUserOrganizationPermissions.some(
                        i =>
                          i.organization == org.Organization_Id &&
                          i.permission == permission.Permission_Id
                      )
                    }"
                  >
                    <input
                      style="display: none"
                      type="checkbox"
                      v-bind:name="
                        org.Organization_Id + 'org' + permission.Permission_Id
                      "
                      v-bind:id="
                        org.Organization_Id + 'org' + permission.Permission_Id
                      "
                      v-bind:value="{
                        organization: org.Organization_Id,
                        permission: permission.Permission_Id
                      }"
                      v-model="newUserOrganizationPermissions"
                    />{{ permission.Title }}
                  </label>
                </div>
              </div>
              <div class="row text-left mt-2">
                <div class="col">
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-on:click="previousPage"
                  >
                    Back
                  </button>
                </div>
                <div class="col-auto">
                  <button type="submit" class="btn btn-primary">
                    Next
                  </button>
                </div>
              </div>
            </form>

            <form
              v-if="page == 5"
              @submit.prevent="sendInvite()"
              key="subjectPermissions"
              class="row"
            >
              <div class="col-12">
                <label>Subject Permissions</label>
                <label
                  ><small
                    >Not selecting one of the options will give no subject level
                    permissions to the user. If the user was given account or
                    organization level permissions, they will apply to the
                    applicable subjects listed.</small
                  ></label
                >
              </div>
              <div
                class="col-6"
                v-for="org in availableOrganizations.filter(
                  o => o.Organization_Type.Organization_Type_Id == 6 || o.Organization_Type.Organization_Type_Id == 7
                )"
                :key="org.Organization_Id"
              >
                <p class="mt-2 mb-0">
                  <b>{{ org.Name }}</b>
                </p>
                <div style="background-color:gray; height:1px; width:100%" />
                <div v-for="sub in org.Subjects" :key="sub.Subject_Id">
                  <p>
                    <b>{{ sub.Title }}</b>
                  </p>
                  <div
                    v-for="permission in Permissions.filter(
                      g => g.Permission_Type.Permission_Type_Id == '3'
                    )"
                    :key="sub.Subject_Id + 'sub' + permission.Permission_Id"
                  >
                    <label
                      class="btn btn-sm"
                      v-bind:for="
                        sub.Subject_Id + 'sub' + permission.Permission_Id
                      "
                      v-bind:class="{
                        'btn-primary': newUserSubjectPermissions.some(
                          i =>
                            i.subject == sub.Subject_Id &&
                            i.permission == permission.Permission_Id
                        ),
                        'btn-outline-primary': !newUserSubjectPermissions.some(
                          i =>
                            i.subject == sub.Subject_Id &&
                            i.permission == permission.Permission_Id
                        )
                      }"
                    >
                      <input
                        style="display: none"
                        type="checkbox"
                        v-bind:name="
                          sub.Subject_Id + 'sub' + permission.Permission_Id
                        "
                        v-bind:id="
                          sub.Subject_Id + 'sub' + permission.Permission_Id
                        "
                        v-bind:value="{
                          subject: sub.Subject_Id,
                          permission: permission.Permission_Id
                        }"
                        v-model="newUserSubjectPermissions"
                      />{{ permission.Title }}
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="row text-left mt-2">
                  <div class="col">
                    <button
                      type="button"
                      class="btn btn-primary"
                      v-on:click="previousPage"
                    >
                      Back
                    </button>
                  </div>
                  <div class="col-auto">
                    <button type="submit" class="btn btn-primary">
                      Send Invite
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Loader from "@/components/Loader.vue";

export default {
  components: {
    Loader
  },
  props: {
    Organizations: Array,
    Permissions: Array,
    AccountId: String,
    ModalId: String
  },
  data() {
    return {
      newEmail: "",
      newPhone: "",
      newConfirmEmail: "",
      newFirstName: "",
      newLastName: "",
      errorMessage: "",
      newUserAccountPermissions: null,
      newUserOrganizationPermissions: [],
      newUserSubjectPermissions: [],
      availableOrganizations: this.Organizations.filter(
        o =>
          this.$canManageAccount(
            this.$store.getters.user.Permissions,
            this.AccountId
          ) ||
          this.$canManageOrganization(
            this.$store.getters.user.Permissions,
            o.Organization_Id
          )
      ),
      existingUser: null,
      page: 1,
      loading: false
    };
  },
  watch: {
    Organizations: function() {
      this.availableOrganizations = this.Organizations.filter(
        o =>
          this.$canManageAccount(
            this.$store.getters.user.Permissions,
            this.AccountId
          ) ||
          this.$canManageOrganization(
            this.$store.getters.user.Permissions,
            o.Organization_Id
          )
      );
    }
  },
  mounted() {
    //var view = this;
    /*document.getElementById("phone").onkeyup = function(e) {
      view.$phoneNumberCheck(this, e);
    };*/
    $("#inviteUserModal" + this.ModalId).on("shown.bs.modal", function() {
      $("#newEmail").focus();
    });
  },
  methods: {
    async signUp() {
      var view = this;
      if (view.newEmail === view.newConfirmEmail) {
        $("#inviteUserModal" + this.ModalId).modal("hide");
        view.$store.commit("updateLoading", true);
        var password = view.$uuidv4();
        try {
          await view
            .$signUpNewUser(view.newEmail, password)
            .then(async authUser => {
              await view.$confirmNewUser(authUser).then(async authUser => {
                await view.createUser(authUser.userSub).then(async newUser => {
                  await view.$emailNewUser(newUser, password);
                  view.$emit("user-added", newUser);
                  view.$store.commit("updateLoading", false);
                  view.$showSnackbar(
                    "An email was sent to the user to complete their profile setup.",
                    true
                  );
                  view.clearForm();
                });
              });
            });
        } catch (e) {
          console.log(e);
          $("#inviteUserModal" + this.ModalId).modal("show");
          view.$store.commit("updateLoading", false);
        }
      } else {
        view.errorMessage =
          "The email address doesn't match. Please check and try again";
      }
    },
    async sendInvite() {
      if (this.existingUser == null) {
        await this.signUp();
      } else {
        $("#inviteUserModal" + this.ModalId).modal("hide");
        this.$store.commit("updateLoading", true);
        await this.$createUserOrganization(
          this.existingUser.User_Id,
          this.Organizations.find(
            o => o.Organization_Type.Organization_Type_Id == 3 || o.Organization_Type.Organization_Type_Id == 4
          ).Organization_Id
        )
          .then(async () => {
            await this.createNewPermissions(this.existingUser.User_Id).then(
              () => {
                this.$store.commit("updateLoading", false);
                this.$emit("user-added", this.existingUser);
              }
            );
          })
          .catch(e => {
            console.log(e);
            this.$store.commit("updateLoading", false);
            $("#inviteUserModal" + this.ModalId).modal("show");
          });
      }
    },
    async createNewPermissions(userId) {
      if (this.newUserAccountPermissions != null) {
        await this.$createUserPermissionsForAccount(
          userId,
          this.AccountId[this.newUserAccountPermissions]
        );
      }
      if (this.newUserOrganizationPermissions.length > 0) {
        await this.$createUserPermissionsForOrganizations(
          userId,
          this.newUserOrganizationPermissions
        );
      }
      if (this.newUserSubjectPermissions.length > 0) {
        await this.$createUserPermissionsForSubjects(
          userId,
          this.newUserSubjectPermissions
        );
      }
    },
    async createUser(cognitoId) {
      var view = this;
      var userToCreate = {
        Cognito_Id: cognitoId,
        First_Name: view.newFirstName,
        Last_Name: view.newLastName,
        Email: view.newEmail.toLowerCase(),
        Phone: view.newPhone != "" ? view.newPhone : "(000) 000-0000"
      };
      return await view
        .$createNewUser(userToCreate)
        .then(async createdUser => {
          createdUser.Organization = view.Organizations.find(
            o => o.Organization_Type.Organization_Type_Id == 3 || o.Organization_Type.Organization_Type_Id == 4
          );
          await view
            .$createUserOrganization(
              createdUser.User_Id,
              createdUser.Organization.Organization_Id
            )
            .then(async () => {
              await view.createNewPermissions(createdUser.User_Id);
            });
          return createdUser;
        })
        .catch(e => console.log(e));
    },
    async nextPage() {
      switch (this.page) {
        case 1:
          if (this.newEmail != this.newConfirmEmail) {
            this.errorMessage = "Email addresses do not match.";
          } else {
            this.errorMessage = "";
            this.loading = true;
            await this.$getUserByEmail(this.newEmail)
              .then(user => {
                this.existingUser = user;
                this.loading = false;
              })
              .catch(e => console.log(e));
            this.page++;
            $("#newEmail").focus();
          }
          break;
        case 2:
          if (
            this.$canManageAccount(
              this.$store.getters.user.Permissions,
              this.AccountId
            )
          ) {
            this.page = 3;
          } else {
            this.page = 4;
          }
          break;
        case 3:
          this.page = 4;
          break;
        case 4:
          this.page = 5;
          break;
      }
    },
    previousPage() {
      this.page -= 1;
    },
    cancel() {
      $("#inviteUserModal" + this.ModalId).modal("hide");
      this.clearForm();
    },
    clearForm() {
      this.newEmail = "";
      this.newPhone = "";
      this.newConfirmEmail = "";
      this.newFirstName = "";
      this.newLastName = "";
      this.errorMessage = "";
      this.newUserAccountPermissions = null;
      this.newUserOrganizationPermissions = [];
      this.newUserSubjectPermissions = [];
      this.page = 1;
    }
  }
};
</script>
